/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_vp_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vapor pressure`)
};

const es_bp_vp_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presión de vapor`)
};

const de_bp_vp_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dampfdruck`)
};

const nl_bp_vp_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dampspanning`)
};

const fr_bp_vp_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pression de vapeur`)
};

const it_bp_vp_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tensione di vapore`)
};

const pt_br2_bp_vp_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pressão de vapor`)
};

const pt_bp_vp_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pressão de vapor`)
};

const ja_bp_vp_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`蒸気圧`)
};

const zh_bp_vp_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`蒸气压`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_vp_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_vp_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_vp_label", locale)
	if (locale === "en") return en_bp_vp_label(inputs)
	if (locale === "es") return es_bp_vp_label(inputs)
	if (locale === "de") return de_bp_vp_label(inputs)
	if (locale === "nl") return nl_bp_vp_label(inputs)
	if (locale === "fr") return fr_bp_vp_label(inputs)
	if (locale === "it") return it_bp_vp_label(inputs)
	if (locale === "pt-BR") return pt_br2_bp_vp_label(inputs)
	if (locale === "pt") return pt_bp_vp_label(inputs)
	if (locale === "ja") return ja_bp_vp_label(inputs)
	return zh_bp_vp_label(inputs)
};